import { DEFAULT_LANG } from './i18n.js';
/**
 * MyID identifikatsiya natija kodlari.
 *
 * Manba: https://docs.myid.uz/#/ru/websdk — «Коды ответов».
 * Kodlar `jobs[].result_code` da keladi.
 *
 * Bu yerdagi matnlar to'g'ridan-to'g'ri sotuvchi ekraniga chiqadi, shuning
 * uchun ular **harakatga chorlovchi** bo'lishi kerak: mijoz nima qilishi
 * kerakligini aytishi lozim, xatolik nomini emas (BT §7.4).
 */
/** Muvaffaqiyatli identifikatsiya kodi. */
export const MYID_SUCCESS_CODE = 1;
/** Kod → qayta urinish ma'noga egami. */
export const MYID_RETRYABLE = {
    1: false,
    2: false,
    3: true,
    4: true,
    5: true,
    6: false,
    9: true,
    10: true,
    11: true,
    12: true,
    13: true,
    14: true,
    15: true,
    16: true,
    17: true,
    18: true,
    19: true,
    20: true,
    21: true,
    22: true,
    23: true,
    24: true,
    25: true,
    26: true,
    27: true,
    28: true,
    29: true,
    30: true,
    31: true,
    32: true,
    33: true,
    34: false,
};
const MYID_MESSAGES_UZ = {
    1: "Identifikatsiya muvaffaqiyatli o'tdi.",
    2: "Pasport ma'lumotlari noto'g'ri kiritilgan. Anketani tekshiring.",
    3: "Tiriklik tekshiruvidan o'tmadi. Qaytadan urinib ko'ring.",
    4: "Aniqlab bo'lmadi. Qaytadan urinib ko'ring.",
    5: "Davlat xizmati (DXM) vaqtincha ishlamayapti. Birozdan so'ng urinib ko'ring.",
    6: 'Ushbu shaxs vafot etgan deb belgilangan.',
    9: "So'rov muddati tugadi. Qaytadan boshlang.",
    10: "Navbatda kutish vaqti tugadi. Qaytadan urinib ko'ring.",
    11: "Xizmat so'rovni bajara olmadi. Birozdan so'ng urinib ko'ring.",
    12: "Xizmat so'rovni bajara olmadi. Birozdan so'ng urinib ko'ring.",
    13: "Xizmat so'rovni bajara olmadi. Birozdan so'ng urinib ko'ring.",
    14: "Yuzni aniqlab bo'lmadi. Yorug'roq joyda qaytadan urinib ko'ring.",
    15: "Xizmat so'rovni bajara olmadi. Birozdan so'ng urinib ko'ring.",
    16: "Xizmat so'rovni bajara olmadi. Birozdan so'ng urinib ko'ring.",
    17: "Shaxsni aniqlab bo'lmadi. Qaytadan urinib ko'ring.",
    18: "So'rovni qayta ishlab bo'lmadi.",
    19: "So'rovni qayta ishlab bo'lmadi.",
    20: 'Rasm sifatsiz yoki xira. Kamerani tozalab, qaytadan urining.',
    21: "Yuz kadrga to'liq tushmadi. Kameraga to'g'ri qarang.",
    22: "Kadrda bir nechta odam bor. Mijoz yolg'iz turishi kerak.",
    23: 'Rangli tasvir talab qilinadi.',
    24: "Qorong'i ko'zoynak aniqlandi. Ko'zoynakni yeching.",
    25: "Bu turdagi rasm qo'llab-quvvatlanmaydi.",
    26: "Ko'zlar yumuq yoki ko'rinmayapti. Ko'zni oching.",
    27: "Bosh yon tomonga burilgan. To'g'ri qarang.",
    28: "Yuz aniqlanmadi yoki to'liq ko'rinmadi.",
    29: 'Kadrda barmoq, qurilma yoki aks etish bor. Ularni olib tashlang.',
    30: "Yuz qisman berkitilgan. Niqob yoki boshqa to'siqni oling.",
    31: 'Kameraga yaqinroq keling.',
    32: "Burun yoki og'iz ko'rinmayapti.",
    33: 'Infraqizil tasvir yuborilmadi.',
    34: 'Shaxsni tasdiqlovchi hujjat muddati tugagan.',
};
const MYID_MESSAGES_RU = {
    1: 'Идентификация прошла успешно.',
    2: 'Паспортные данные введены неверно. Проверьте анкету.',
    3: 'Проверка живости не пройдена. Попробуйте ещё раз.',
    4: 'Не удалось распознать. Попробуйте ещё раз.',
    5: 'Госслужба (ГЦП) временно недоступна. Попробуйте чуть позже.',
    6: 'Этот человек отмечен как умерший.',
    9: 'Время запроса истекло. Начните заново.',
    10: 'Время ожидания в очереди истекло. Попробуйте ещё раз.',
    11: 'Сервис не смог обработать запрос. Попробуйте чуть позже.',
    12: 'Сервис не смог обработать запрос. Попробуйте чуть позже.',
    13: 'Сервис не смог обработать запрос. Попробуйте чуть позже.',
    14: 'Лицо не распознано. Попробуйте при лучшем освещении.',
    15: 'Сервис не смог обработать запрос. Попробуйте чуть позже.',
    16: 'Сервис не смог обработать запрос. Попробуйте чуть позже.',
    17: 'Личность не установлена. Попробуйте ещё раз.',
    18: 'Не удалось обработать запрос.',
    19: 'Не удалось обработать запрос.',
    20: 'Снимок нечёткий или размытый. Протрите камеру и попробуйте снова.',
    21: 'Лицо не поместилось в кадр. Смотрите прямо в камеру.',
    22: 'В кадре несколько человек. Клиент должен быть один.',
    23: 'Требуется цветное изображение.',
    24: 'Обнаружены тёмные очки. Снимите очки.',
    25: 'Такой тип изображения не поддерживается.',
    26: 'Глаза закрыты или не видны. Откройте глаза.',
    27: 'Голова повёрнута в сторону. Смотрите прямо.',
    28: 'Лицо не обнаружено или видно не полностью.',
    29: 'В кадре палец, устройство или блики. Уберите их.',
    30: 'Лицо частично закрыто. Снимите маску или другую преграду.',
    31: 'Подойдите ближе к камере.',
    32: 'Не видно нос или рот.',
    33: 'Инфракрасное изображение не передано.',
    34: 'Срок действия документа истёк.',
};
export const MYID_MESSAGES = {
    uz: MYID_MESSAGES_UZ,
    ru: MYID_MESSAGES_RU,
};
const UNFINISHED = {
    uz: 'Identifikatsiya yakunlanmadi.',
    ru: 'Идентификация не завершена.',
};
const UNKNOWN_CODE = {
    uz: (code) => `Identifikatsiya o'tmadi (kod ${code}).`,
    ru: (code) => `Идентификация не пройдена (код ${code}).`,
};
export function myIdResultInfo(code, lang = DEFAULT_LANG) {
    const table = MYID_MESSAGES[lang] ?? MYID_MESSAGES[DEFAULT_LANG];
    if (code === null || code === undefined) {
        return { message: UNFINISHED[lang] ?? UNFINISHED[DEFAULT_LANG], retryable: true };
    }
    const message = table[code];
    if (!message) {
        const fallback = UNKNOWN_CODE[lang] ?? UNKNOWN_CODE[DEFAULT_LANG];
        return { message: fallback(code), retryable: true };
    }
    return { message, retryable: MYID_RETRYABLE[code] ?? true };
}
export function isMyIdSuccess(code) {
    return code === MYID_SUCCESS_CODE;
}
/**
 * Muvaffaqiyatsiz identifikatsiya haqida ekranga qaysi matn chiqadi.
 *
 * MyID kodi bilan bizning natijamiz har doim mos tushavermaydi. Jonli
 * misol: MyID «muvaffaqiyatli o'tdi» deb javob beradi, biz esa rasmni
 * yuklab ololmaymiz — provayderlarga yuborishga narsa yo'q, ya'ni natija
 * muvaffaqiyatsiz. Kod bo'yicha lug'atdan matn olsak, ekranda
 * «Identifikatsiya o'tmadi» sarlavhasi ostida «muvaffaqiyatli o'tdi»
 * turadi. Shuning uchun bunday holatda serverning o'z sababi ustun.
 *
 * Qolgan hollarda lug'at ustun: sotuvchi tilni almashtirsa, matn
 * serverdan qayta so'ralmasdan tarjima bo'ladi.
 */
export function myIdFailureMessage(code, serverMessage, lang = DEFAULT_LANG) {
    if (code === null || code === undefined || isMyIdSuccess(code)) {
        return serverMessage || myIdResultInfo(code, lang).message;
    }
    return myIdResultInfo(code, lang).message;
}
/**
 * Web SDK iframe'dan `postMessage` orqali keladigan holatlar.
 * DIQQAT: bu faqat frontend hodisalari. Identifikatsiya haqiqatan o'tganini
 * faqat backend orqali tekshirish mumkin (hujjat talabi).
 */
export const MyIdSdkStatus = {
    EXCEPTION: -1,
    IN_PROGRESS: 0,
    LIVENESS_PASSED: 1,
    LIVENESS_FAILED: 2,
    RETRY: 3,
    EXITED: 4,
    LOADING: 100,
    LOADED: 101,
};
//# sourceMappingURL=myid-codes.js.map